module.exports = __webpack_public_path__ + "static/media/oval2.d938fd82.svg";